// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__BkgyO","content":"index_content__6GDdV","title":"index_title__JKksm","desc":"index_desc__JzcC3","btn":"index_btn__fOZ1H"};